<script>
    export let status = 403
    export let message = 'You do not have permission to access this page'
</script>

<div class="flex flex-col items-center justify-center min-h-screen text-center">
    <h1 class="text-6xl font-bold">{status}</h1>
    <p class="text-xl mt-2">{message}</p>
    <a href="/" class="mt-4 text-blue-600 hover:underline">Go back home</a>
</div>
